module.exports = __webpack_public_path__ + "static/media/300_1.c0bc77c1.jpg";